<template>
    <div class="case">
    
        <div class="img-tab">
        <el-carousel ref="bannerCarousel" style="height: 600px;width:90%;left:5%" :interval="3000" arrow="always" >
          <el-carousel-item :style="{height:carouselHeight,overflow:'hidden'}">
            <div :ref="`banner-div-0`" style="background: transparent;">
              <img style="width: 100%; background-size: 70%; filter:brightness(70%) " src="@/assets/service/91.png" fit="fill" :ref="`banner-img-0`" @load="initDivHeight(0)"/>
            </div>
          </el-carousel-item>
          <el-carousel-item :style="{height:carouselHeight,overflow:'hidden'}">
            <div :ref="`banner-div-1`" style="background: transparent;">
              <img style="width: 100%;filter:brightness(100%)" src="@/assets/product/011.png" fit="fill" :ref="`banner-img-1`" @load="initDivHeight(1)"/>
            </div>
          </el-carousel-item>
          <el-carousel-item :style="{height:carouselHeight,overflow:'hidden'}">
            <div :ref="`banner-div-1`" style="background: transparent;">
              <img style="width: 100%;background-size: 70%;filter:brightness(90%)" src="@/assets/service/93.png" fit="fill" :ref="`banner-img-1`" @load="initDivHeight(2)"/>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    
    <div style="display: flex;width:100%;margin-top:50px;">
        <div align="left"  style="width:100%;font-size: 18px;margin-left:20%;">
        <h2>业务介绍</h2>
        <p style="text-indent:3em;">在当今数字化浪潮中，辽宁智领未来科技有限公司凭借卓越的技术实力与创新精神，专注于多领域的前沿业务开发</p>
        <p style="text-indent:3em;">于应用系统开发层面，我们擅长打造多样化的桌面应用程序与先进的 Web 应用程序。无论是满足企业内部高效办公需求的桌面软件，还是面向广大</p>
        <p style="text-indent:1em;">互联网用户、具备丰富交互功能的 Web 应用，我们都能凭借精湛的编程技艺与对用户体验的深刻理解，交付高品质、定制化的解决方案。从软件的</p>
        <p style="text-indent:1em;">界面设计到功能架构搭建，从性能优化到安全防护，每一个环节都经过精心雕琢，以确保产品在市场竞争中脱颖而出。</p>
        <p style="text-indent:3em;">在人工智能开发领域，公司展现出强大的研发实力。从人工智能基础软件开发筑牢技术根基，研发出高效的机器学习算法框架和智能数据处理模型，</p>
        <p style="text-indent:1em;">到人工智能应用软件开发精准对接各行业需求，再到构建人工智能公共数据平台汇聚与整合海量数据资源，整合多源异构数据并进行标准化处理，为</p>
        <p style="text-indent:1em;">人工智能的深度应用与持续发展提供坚实支撑，助力企业与社会在智能化转型道路上大步迈进。</p>

        <p style="text-indent:3em;">大数据与物联网服务亦是我们的核心业务板块。提供专业的数据处理和存储支持服务，运用先进的数据仓库技术和分布式存储架构，确保数据的安全</p>
        <p style="text-indent:1em;">高效管理与精准分析；积极开展物联网iot平台开发，实现万物互联的智能场景构建；如智能城市的路灯远程监控与节能调控、工业生产的设备智能</p>
        <p style="text-indent:1em;">运维与故障预警；通过信息系统集成服务，将各类信息技术与业务流程深度融合，为客户打造一体化、智能化的信息生态系统，实现企业内部各部门</p>
        <p style="text-indent:1em;">间的信息无缝流通与协同作业。</p>
        <p style="text-indent:3em;">此外，公司以定制化解决方案为特色。深入剖析各行业现状，精准优化业务流程，有效破解行业痛点，显著提升业务效率。无论是大数据开发、人工智</p>
        <p style="text-indent:1em;">能开发、物联网平台还是智能算法等领域，我们都能为客户量身打造专属的科技解决方案，借助物联网和智能算法实现高效调度。用智慧与技术引领行</p>
        <p style="text-indent:1em;">业走向更高效、智能的未来，携手合作伙伴共创无限可能，智领科技发展新潮流。</p>
       
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
     
     

        </div>
     
      <!-- <div>
        <img  style="transform:scale(0.8)"  src="@/assets/logo5.png" alt="">
      </div> -->
    </div>
    </div>
  </template>
  
  <script>
  export default { 
    name: 'service',
    components: {
    },
    data(){
      return{
        types:[],
        carouselHeight:'600px',
      }
    },
    methods:{
    
    },
    mounted(){
     
    }
  }
  </script>
  
  <style lang="scss" >
   .case{
    position: relative;
    justify-content: flex-start;
    text-align: center;
    width:100%;
    height:100%;
    display:flex;
    align-content: center;
    flex-direction: column;
    background: #fff;
   
  }
  .product_head{
  
    // align-items: center;
    height: 500px;
    width:100%;
  }


  
  .el-carousel{
    width: 100%;
   
  }
  </style>
  